import { TOGGLE_SIDEBAR } from '../constants/ActionTypes'
import GenericAction from './types/genericAction.types'

type SidebarAction = GenericAction<typeof TOGGLE_SIDEBAR, { sidebar: boolean }>

export default (state = false, { type, sidebar }: SidebarAction) => {
    switch (type) {
        case TOGGLE_SIDEBAR:
            return sidebar
        default:
            return state
    }
}
